import Formula from "../singleton/formula";

export default {

    getNumberSubstitutions: Formula.getNumberSubstitutions.bind(Formula),

    getDatetimeSubstitutions: Formula.getDatetimeSubstitutions.bind(Formula),

    Expression: {

        format: Formula.expressionFormat.bind(Formula),

        valid: Formula.expressionValid.bind(Formula)

    }

}